import { SiteFooter } from "~/components/site-footer";
import { SiteHeader } from "~/components/site-header";

interface LandingPageLayoutProps {
  children: React.ReactNode;
}

export default function LandingPageLayout({
  children,
}: LandingPageLayoutProps) {
  return (
    <>
      {/* <SiteBanner /> */}
      <SiteHeader />
      <main className="mx-auto flex-1 overflow-hidden min-h-[100vh]">{children}</main>
      <SiteFooter />
    </>
  );
}
